// extracted by mini-css-extract-plugin
export default {"productDescription":"__-z","featuredDescription":"aaa-z","description":"baa-z","more":"caa-z","descriptionSku":"daa-z"};